/*Author - Subhalakshmi S
Date - 20-03-2025
Task - Site Settings */
import React, { useEffect, useState } from "react";
import AdminLayout from "../../../components/layouts/adminLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import AdminPageHeader from "../../../components/AdminPageHeader";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import SiteSettingsService from "../../../services/API/SiteSettings";
import { Tabs, Tab } from "react-bootstrap";
import Editor from "../../../components/common/Editor/Editor"; //11-04-2025 - terms and condition - Subha
import {
    validateEmail,
    formatMobileNumber,
} from "../../../utils/utils";

export default function SiteSettings() {
    const [contact_number, setContactNumber] = useState("");
    const [contact_email, setContactEmail] = useState("");
    const [marketing_email, setMarketingEmail] = useState("");
    const [partner_number, setPartnerNumber] = useState("");
    const [helpdesk, setHelpdesk] = useState("");
    const [refunds, setRefunds] = useState("");
    const [address, setAddress] = useState("");
    const [timings, setTimings] = useState("");
    const [happy_clients, setHappyClients] = useState("");
    const [license_procured, setLicenseProcured] = useState("");
    const [license_offered, setLicenseOffered] = useState("");
    const [cities_serviced, setCitiesServed] = useState("");
    const [support_email, setSupportEmail] = useState("");  //08-04-2025 - support email - Subha
    const [terms_condition, setTermsandCondition] = useState("");  //11-04-2025 - terms and condition - Subha
    const [new_user_email, setNewUserEmail] = useState("");
    const [enquiry_email, setEnquiryEmail] = useState("");
    const [renewal_amendments_cc_email, setRenewalAmendmentsCcEmail] = useState("");
    const emailValidate = /^[a-zA-Z0-9._]+@[a-zA-Z0-9.]+\.[a-zA-Z]{2,}$/;

    const navigate = useNavigate();

    useEffect(() => {
        siteDetails();
    }, []);

    const siteDetails = async () => {
        try {
            const siteData = await SiteSettingsService.getSiteDetails();
            if (siteData.status == 'success') {
                setContactNumber(siteData.data.contact_number);
                setContactEmail(siteData.data.contact_email);
                setMarketingEmail(siteData.data.marketing_email);
                setPartnerNumber(siteData.data.partner_number);
                setHelpdesk(siteData.data.helpdesk);
                setRefunds(siteData.data.refunds);
                setAddress(siteData.data.address);
                setTimings(siteData.data.timings);
                setHappyClients(siteData.data.happy_clients);
                setLicenseProcured(siteData.data.license_procured);
                setLicenseOffered(siteData.data.license_offered);
                setCitiesServed(siteData.data.cities_serviced);
                setSupportEmail(siteData.data.support_email); //08-04-2025 - support email - Subha
                setTermsandCondition(siteData.data.terms_and_condition); //11-04-2025 - support email - Subha
                setNewUserEmail(siteData.data.new_user_email);
                setEnquiryEmail(siteData.data.enquiry_email);
                setRenewalAmendmentsCcEmail(siteData.data.renewal_amendments_cc_email);
            }
        } catch (er) {
            toast.error(er);
        }
    };

    const submitContact = async () => {
        const payload = {
            contact_number: contact_number,
            contact_email: contact_email,
            marketing_email: marketing_email,
            partner_number: partner_number,
            helpdesk: helpdesk,
            refunds: refunds,
            address: address,
            timings: timings
        };
        const error = validateContact(payload);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await SiteSettingsService.updateContact(payload);
            if (response) {
                toast.success("Contact details updated successfully");
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const validateContact = (data) => {
        if (!data.contact_number) return "Please enter contact number";
        if (parseInt(formatMobileNumber(data.contact_number)) < 999999999)
            return "Please enter valid 10 digit contact number";
        if (String(formatMobileNumber(data.contact_number))?.length != 10)
            return "Please enter valid 10 digit contact number";
        if (!data.contact_email) return "Please enter contact email";
        if (!validateEmail(data.contact_email)) return "Please enter valid contact e-mail ID";
        if (!data.marketing_email) return "Please enter marketing email";
        if (!validateEmail(data.marketing_email)) return "Please enter valid e-mail ID";
        if (!data.partner_number) return "Please enter partner number";
        if (parseInt(formatMobileNumber(data.partner_number)) < 999999999)
            return "Please enter valid 10 digit partner number";
        if (String(formatMobileNumber(data.partner_number))?.length != 10)
            return "Please enter valid 10 digit partner number";
        if (!data.helpdesk) return "Please enter helpdesk";
        if (!validateEmail(data.helpdesk)) return "Please enter valid helpdesk e-mail ID";
        if (!data.refunds) return "Please enter refunds";
        if (!validateEmail(data.refunds)) return "Please enter valid refunds e-mail ID";
        if (!data.address) return "Please enter address";
        if (!data.timings) return "Please enter timings";
    };

    const submitILS = async () => {
        const payload = {
            happy_clients: happy_clients,
            license_procured: license_procured,
            license_offered: license_offered,
            cities_serviced: cities_serviced,
        };
        const error = validateILS(payload);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await SiteSettingsService.updateILS(payload);
            if (response) {
                toast.success("ILS details updated successfully");
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const validateILS = (data) => {
        if (!data.happy_clients) return "Please enter happy clients";
        if (!data.license_procured) return "Please enter license procured";
        if (!data.license_offered) return "Please enter license offered";
        if (!data.cities_serviced) return "Please enter cities serviced";
    };
    //08-04-2025 - support email - Subha
    const submitSupport = async () => {
        const payload = {
            support_email : support_email,
            new_user_email : new_user_email,
            enquiry_email : enquiry_email,
            renewal_amendments_cc_email : renewal_amendments_cc_email
        };
        const error = validateSupport(payload);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await SiteSettingsService.updateSupport(payload);
            if (response) {
                toast.success("Support details updated successfully");
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const validateSupport = (data) => {
        if (!data.support_email) return "Please enter support email";
        // if (!validateEmail(data.support_email)) return "Please enter valid support e-mail ID";
        if (!data.renewal_amendments_cc_email) return "Please enter renewal amendments bcc email";
    };

    //11-04-2025 - terms and condition - Subha
    const submitTerms = async () => {
        const payload = {
            terms_and_condition: terms_condition,
        };
        const error = validateTerms(payload);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await SiteSettingsService.updateTerms(payload);
            if (response) {
                toast.success("Terms and condition updated successfully");
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const validateTerms = (data) => {
        if (!data.terms_and_condition) return "Please enter terms and condition";
    };

    const submitNewUserEmail = async () => {
        const payload = {
            new_user_email: new_user_email,
        };
        const error = validateNewUserEmail(payload);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await SiteSettingsService.updateNewUserEmail(payload);
            if (response) {
                toast.success("New user notify email updated successfully");
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const validateNewUserEmail = (data) => {
        if (!data.new_user_email) return "Please enter new user notify email";
        else if (
            data.new_user_email.split("@")[0].length < 3 ||
            data.new_user_email.split("@")[0].length > 500
        ) {
            return "Please enter valid email";
        } else if (!emailValidate.test(data.new_user_email))
            return "Please enter valid email";
    };

    return (
        <AdminLayout test="active">
            <AdminPageContainer>
                <div id="main" role="main">
                    <div id="content">
                        <div>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item ">
                                    <a
                                        style={{
                                            color: "blue",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => navigate("/system-admin/license-master")}
                                        onKeyDown={() => navigate("/system-admin/license-master")}
                                    >
                                        Home
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Website Content Management</li>

                                <li className="breadcrumb-item active">Site Settings</li>
                            </ol>
                        </div>

                        <div>
                            {/* {!dataFetchedRef.current ? (
                        <div className="text-center">Loading...</div>
                    ) : ( */}
                            <div className="row">
                                <div className="col-md-6 col-lg-12">
                                    <div className="card card-sm card-shadow mb-3">
                                        <div className="card-body">
                                            <AdminPageHeader title="Site Settings" />
                                            <Tabs
                                                defaultActiveKey="contact us"
                                                transition={false}
                                                unmountOnExit={true}
                                                mountOnEnter={true}
                                                className=" bordered p-0 m-0"
                                            >
                                                <Tab
                                                    eventKey="contact us"
                                                    title="Contact Us"
                                                    tabClassName="rounded-0"
                                                >
                                                    <form className="smart-form">
                                                        <fieldset>
                                                            <div className="row">
                                                                {/* <h3
                                                                style={{
                                                                paddingLeft: "15px",
                                                                paddingBottom: "10px",
                                                                }}
                                                            >
                                                                Contact Us{" "}
                                                            </h3> */}
                                                                <section className="col col-4">
                                                                    <label className="label">
                                                                        Contact Number{" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <input
                                                                            type="text"
                                                                            className="input-sm"
                                                                            value={contact_number && formatMobileNumber(contact_number)}
                                                                            maxLength={10}
                                                                            onChange={(e) => setContactNumber(e.target.value)}
                                                                            placeholder
                                                                        />
                                                                    </label>
                                                                </section>
                                                                <section className="col col-4">
                                                                    <label className="label">
                                                                        Contact Email{" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <input
                                                                            type="text"
                                                                            className="input-sm"
                                                                            placeholder
                                                                            value={contact_email}
                                                                            onChange={(e) => setContactEmail(e.target.value)}
                                                                        />
                                                                    </label>
                                                                </section>
                                                                <section className="col col-4">
                                                                    <label className="label">
                                                                        Marketing Email{" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <input
                                                                            type="text"
                                                                            className="input-sm"
                                                                            onChange={(e) => setMarketingEmail(e.target.value)}
                                                                            value={marketing_email}
                                                                            placeholder
                                                                        />
                                                                    </label>
                                                                </section>
                                                                <section className="col col-4">
                                                                    <label className="label">
                                                                        Partner Number{" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <input
                                                                            type="text"
                                                                            className="input-sm"
                                                                            value={partner_number && formatMobileNumber(partner_number)}
                                                                            maxLength={10}
                                                                            onChange={(e) => setPartnerNumber(e.target.value)}
                                                                            placeholder
                                                                        />
                                                                    </label>
                                                                </section>
                                                                <section className="col col-4">
                                                                    <label className="label">
                                                                        Helpdesk{" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <input
                                                                            type="text"
                                                                            className="input-sm"
                                                                            onChange={(e) => setHelpdesk(e.target.value)}
                                                                            value={helpdesk}
                                                                            placeholder
                                                                        />
                                                                    </label>
                                                                </section>
                                                                <section className="col col-4">
                                                                    <label className="label">
                                                                        Refunds{" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <input
                                                                            type="text"
                                                                            className="input-sm"
                                                                            onChange={(e) => setRefunds(e.target.value)}
                                                                            value={refunds}
                                                                            placeholder
                                                                        />
                                                                    </label>
                                                                </section>
                                                                <section className="col col-8">
                                                                    <label className="label">
                                                                        Address{" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <textarea
                                                                            placeholder="Enter Address"
                                                                            rows="3"
                                                                            style={{
                                                                                width: "100%",
                                                                                border: "1px solid #ccc",
                                                                                padding: "4px 0px 0 5px",
                                                                            }}
                                                                            name="address"
                                                                            onChange={(e) => setAddress(e.target.value)}
                                                                            value={address}
                                                                        ></textarea>
                                                                    </label>
                                                                </section>
                                                                <section className="col col-8">
                                                                    <label className="label">
                                                                        Business Hours{" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <textarea
                                                                            placeholder="Enter Business Hours"
                                                                            rows="3"
                                                                            style={{
                                                                                width: "100%",
                                                                                border: "1px solid #ccc",
                                                                                padding: "4px 0px 0 5px",
                                                                            }}
                                                                            name="timings"
                                                                            onChange={(e) => setTimings(e.target.value)}
                                                                            value={timings}
                                                                        ></textarea>
                                                                    </label>
                                                                </section>
                                                            </div>
                                                        </fieldset>

                                                        <footer>
                                                            <button
                                                                type="button"
                                                                className="btn button_new button_new_success"
                                                                onClick={submitContact}
                                                            >
                                                                Save
                                                            </button>
                                                        </footer>
                                                    </form>
                                                </Tab>
                                                {/* <Tab
                                                eventKey="ils"
                                                title="ILS"
                                                tabClassName="rounded-0"
                                            >                        
                                                <form className="smart-form">
                                                    <fieldset>
                                                        <div className="row">
                                                            // <h3
                                                            //     style={{
                                                            //     paddingLeft: "15px",
                                                            //     paddingBottom: "10px",
                                                            //     }}
                                                            // >
                                                            //     ILS Numbers {" "}
                                                            // </h3>
                                                            <section className="col col-3">
                                                                <label className="label">
                                                                Happy Clients {" "}
                                                                <span style={{ color: "red" }}> *</span>
                                                                </label>
                                                                <label className="input">
                                                                <input
                                                                    type="text"
                                                                    className="input-sm"
                                                                    onChange={(e) => setHappyClients(e.target.value)}
                                                                    value={happy_clients}
                                                                    placeholder
                                                                />
                                                                </label>
                                                            </section>
                                                            <section className="col col-3">
                                                                <label className="label">
                                                                Licenses Procured {" "}
                                                                <span style={{ color: "red" }}> *</span>
                                                                </label>
                                                                <label className="input">
                                                                <input
                                                                    type="text"
                                                                    className="input-sm"
                                                                    onChange={(e) => setLicenseProcured(e.target.value)}
                                                                    value={license_procured}
                                                                    placeholder
                                                                />
                                                                </label>
                                                            </section>
                                                            <section className="col col-3">
                                                                <label className="label">
                                                                Unique Licenses Offered {" "}
                                                                <span style={{ color: "red" }}> *</span>
                                                                </label>
                                                                <label className="input">
                                                                <input
                                                                    type="text"
                                                                    className="input-sm"
                                                                    onChange={(e) => setLicenseOffered(e.target.value)}
                                                                    value={license_offered}
                                                                    placeholder
                                                                />
                                                                </label>
                                                            </section>
                                                            <section className="col col-3">
                                                                <label className="label">
                                                                Cities Serviced {" "}
                                                                <span style={{ color: "red" }}> *</span>
                                                                </label>
                                                                <label className="input">
                                                                <input
                                                                    type="text"
                                                                    className="input-sm"
                                                                    onChange={(e) => setCitiesServed(e.target.value)}
                                                                    value={cities_serviced}
                                                                    placeholder
                                                                />
                                                                </label>
                                                            </section>
                                                        </div>
                                                    </fieldset>

                                                    <footer>
                                                        <button
                                                        type="button"
                                                        className="btn button_new button_new_success"
                                                        onClick={submitILS}
                                                        >
                                                        Save
                                                        </button>
                                                    </footer>
                                                </form>
                                            </Tab> */}
                                                <Tab //08-04-2025 - support email - Subha
                                                    eventKey="support"
                                                    title="Email"
                                                    tabClassName="rounded-0"
                                                >
                                                    <form className="smart-form">
                                                        <fieldset>
                                                            <div className="row">
                                                                {/* <h3
                                                                style={{
                                                                paddingLeft: "15px",
                                                                paddingBottom: "10px",
                                                                }}
                                                            >
                                                                Support Details {" "}
                                                            </h3> */}
                                                                <section className="col col-6">
                                                                    <label className="label">
                                                                        Support Email {" "}
                                                                        <span style={{ color: "red" }}> *</span> <small style={{ color: "#7b818d" }}>(Ex: sample@gmail.com,sampleone@gmail.com)</small>
                                                                    </label>
                                                                    <label className="input">
                                                                        <textarea
                                                                            placeholder="Enter email"
                                                                            rows="3"
                                                                            style={{
                                                                                width: "100%",
                                                                                border: "1px solid #ccc",
                                                                                padding: "4px 0px 0 5px",
                                                                            }}
                                                                            onChange={(e) => setSupportEmail(e.target.value)}
                                                                            value={support_email}
                                                                        ></textarea>
                                                                    </label>
                                                                    <label className="label">
                                                                        New User Notify Email {" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <textarea
                                                                            placeholder="Enter email"
                                                                            rows="3"
                                                                            style={{
                                                                                width: "100%",
                                                                                border: "1px solid #ccc",
                                                                                padding: "4px 0px 0 5px",
                                                                            }}
                                                                            onChange={(e) => setNewUserEmail(e.target.value)}
                                                                            value={new_user_email}
                                                                        ></textarea>
                                                                    </label>
                                                                    <label className="label">
                                                                        Enquiry Email  {" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <textarea
                                                                            placeholder="Enter email"
                                                                            rows="3"
                                                                            style={{
                                                                                width: "100%",
                                                                                border: "1px solid #ccc",
                                                                                padding: "4px 0px 0 5px",
                                                                            }}
                                                                            onChange={(e) => setEnquiryEmail(e.target.value)}
                                                                            value={enquiry_email}
                                                                        ></textarea>
                                                                    </label>
                                                                    <label className="label">
                                                                        Renewal Amendments BCC Email {" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <textarea
                                                                            placeholder="Enter email"
                                                                            rows="3"
                                                                            style={{
                                                                                width: "100%",
                                                                                border: "1px solid #ccc",
                                                                                padding: "4px 0px 0 5px",
                                                                            }}
                                                                            onChange={(e) => setRenewalAmendmentsCcEmail(e.target.value)}
                                                                            value={renewal_amendments_cc_email}
                                                                        ></textarea>
                                                                    </label>
                                                                </section>
                                                            </div>
                                                        </fieldset>

                                                        <footer>
                                                            <button
                                                                type="button"
                                                                className="btn button_new button_new_success"
                                                                onClick={submitSupport}
                                                            >
                                                                Save
                                                            </button>
                                                        </footer>
                                                    </form>
                                                </Tab>
                                                <Tab //08-04-2025 - terms and condition - Subha
                                                    eventKey="terms"
                                                    title="License Terms and Condition"
                                                    tabClassName="rounded-0"
                                                >
                                                    <form className="smart-form">
                                                        <fieldset>
                                                            <div className="row">
                                                                {/* <h3
                                                                style={{
                                                                paddingLeft: "15px",
                                                                paddingBottom: "10px",
                                                                }}
                                                            >
                                                                Support Details {" "}
                                                            </h3> */}
                                                                <section className="col col-6">
                                                                    <label className="label">
                                                                        Terms and Condition {" "}
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <label className="input">
                                                                        <textarea
                                                                            placeholder="Enter terms and condition"
                                                                            rows="3"
                                                                            style={{
                                                                                width: "100%",
                                                                                border: "1px solid #ccc",
                                                                                padding: "4px 0px 0 5px",
                                                                            }}
                                                                            onChange={(e) => setTermsandCondition(e.target.value)}
                                                                            value={terms_condition}
                                                                        ></textarea>
                                                                    </label>
                                                                </section>
                                                            </div>
                                                        </fieldset>

                                                        <footer>
                                                            <button
                                                                type="button"
                                                                className="btn button_new button_new_success"
                                                                onClick={submitTerms}
                                                            >
                                                                Save
                                                            </button>
                                                        </footer>
                                                    </form>
                                                </Tab>
                                            </Tabs>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* )} */}
                        </div>
                    </div>
                </div>
            </AdminPageContainer>
        </AdminLayout>
    );
}
